import Keycloak from "keycloak-js";
import ApiGael from "@/services/apiGael.service";
import ApiAdmin from "@/services/apiAdmin.service";
import ApiLandingEadstock from "@/services/apiLandingEadstock.service";
import {
  createKeycloakStub,
  isKeycloakBypassEnabled
} from "@/common/keycloakStub";

import {
  MY_ACCOUNT_REDIRECT,
  LOGOUT,
  PLATFORM_GROUP,
  INIT_KEYCLOAK,
  INIT_APIS,
  SET_KEYCLOAK,
  SET_TOKEN,
  LOGIN,
  UPDATE_TOKEN,
  USER_CREATE
} from "@/store/actions/actions.type";
import {
  CREATE_KEYCLOAK,
  CREATE_TOKEN
} from "@/store/mutations/mutations.type";
import {
  PROTOCOL,
  CLIENT_ID,
  KEYCLOAK_REALM,
  KEYCLOAK_AUTH_ROLE,
  MY_ACCOUNT_REDIRECT_URL
} from "@/common/config";

const keycloakInitOptions = {
  url: PROTOCOL + "//accounts.eadstock.com.br/auth",
  realm: KEYCLOAK_REALM,
  clientId: CLIENT_ID
};

const state = {
  keycloak: {}
};

const getters = {
  keycloak(state) {
    return state.keycloak;
  },
  isAuthenticated(state) {
    return state.keycloak.authenticated;
  }
};

const actions = {
  [PLATFORM_GROUP](context) {
    return new Promise((resolve, reject) => {
      ApiAdmin.post("platforms/create")
        .then(response => {
          resolve();
        })
        .catch(e => {
          reject(e.response);
        });
    });
  },
  [INIT_KEYCLOAK](context) {
    return new Promise((resolve, reject) => {
      if (isKeycloakBypassEnabled()) {
        const keycloak = createKeycloakStub();
        // eslint-disable-next-line no-console
        console.info(
          "[DEV_BYPASSER] login do Keycloak ignorado — usando DEV_B42@b42.com.br. " +
            "Para usar Keycloak real: localStorage.setItem('keycloakReal', '1') e recarregue."
        );
        context.dispatch(SET_KEYCLOAK, keycloak).then(() => {
          context.dispatch(INIT_APIS, true).then(() => {
            resolve();
          });
        });
        return;
      }

      const keycloak = new Keycloak(keycloakInitOptions);
      keycloak
        .init({
          onLoad: "check-sso",
          silentCheckSsoRedirectUri:
            window.location.origin + "/silent-check-sso.html",
          promiseType: "native"
        })
        .then(isAuth => {
          if (!isAuth) {
            keycloak.login();
            return;
          }

          context.dispatch(SET_KEYCLOAK, keycloak).then(() => {
            context.dispatch(INIT_APIS, isAuth).then(() => {
              resolve();
            });
          });
        })
        .catch(e => {
          reject(`Keycloak init error ${e}`);
        });
    });
  },
  [INIT_APIS](context, isAuth) {
    return new Promise((resolve, reject) => {
      Promise.all([ApiLandingEadstock.init(), ApiGael.init(), ApiAdmin.init()])
        .then(() => {
          if (isAuth) {
            context.dispatch(SET_TOKEN, state.keycloak.token);
            context.dispatch(`user/${USER_CREATE}`, state.keycloak, {
              root: true
            });
          }
          resolve();
        })
        .catch(e => {
          console.log(e);
        });
    });
  },
  //Não utilizado por enquanto
  [LOGIN](context) {
    state.keycloak.login();
  },
  [SET_KEYCLOAK](context, keycloakInstance) {
    return new Promise(resolve => {
      context.commit(CREATE_KEYCLOAK, keycloakInstance);
      resolve();
    });
  },
  [MY_ACCOUNT_REDIRECT](context) {
    return new Promise(resolve => {
      window.location.href = MY_ACCOUNT_REDIRECT_URL;
      resolve();
    });
  },
  [LOGOUT](context) {
    return new Promise(resolve => {
      state.keycloak.logout();
      resolve();
    });
  },
  [SET_TOKEN](context, token) {
    return new Promise(resolve => {
      context.commit(CREATE_TOKEN, token);
      resolve();
    });
  },
  [UPDATE_TOKEN](context) {
    return new Promise((resolve, reject) => {
      state.keycloak
        .updateToken()
        .then(() => {
          Promise.all([context.dispatch(SET_TOKEN, state.keycloak.token)]).then(
            () => {
              if (!state.keycloak.hasResourceRole(KEYCLOAK_AUTH_ROLE)) {
                context.dispatch(MY_ACCOUNT_REDIRECT);
                reject("Aplicação não autorizada!");
                return;
              }
              resolve();
            }
          );
        })
        .catch(() => {
          state.keycloak.logout();
        });
    });
  }
};

const mutations = {
  [CREATE_KEYCLOAK](state, keycloakInstance) {
    state.keycloak = keycloakInstance;
    DEBUG["keycloak"] = keycloakInstance;
  },
  [CREATE_TOKEN](state, token) {
    ApiGael.setTokenHeader(token);
    ApiAdmin.setTokenHeader(token);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
